import { render, staticRenderFns } from "./SupportInfo.vue?vue&type=template&id=b6a95eba&scoped=true"
import script from "./SupportInfo.vue?vue&type=script&lang=js"
export * from "./SupportInfo.vue?vue&type=script&lang=js"
import style0 from "./SupportInfo.vue?vue&type=style&index=0&id=b6a95eba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a95eba",
  null
  
)

export default component.exports